var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"action-notice-approve-document"},[_c('div',{staticClass:"title f-bold",domProps:{"innerHTML":_vm._s(_vm.title)}}),_c('div',{staticClass:"body"},[_c('div',{domProps:{"innerHTML":_vm._s(_vm.body)}})])])}
var staticRenderFns = []

export { render, staticRenderFns }